// Add your custom JS here.

// Animation effect library for npm splitting and scroll-out
import Splitting from "splitting";
import ScrollOut from "scroll-out";


// Split text into words and characters for animating h1 on page load
Splitting({ target: '.animate-heading h1' });

// Split text into words and characters for animating
Splitting({ target: '.animate-heading h2' });
ScrollOut({
  targets: ['.word', '.animate-heading']
});

// Flip Effect Animation on any item with the .flipx class
ScrollOut({
  targets:'.flipx',
  onShown: function(el) {
   // remove the class
   el.classList.remove('animate__animated', 'animate__flipInX');
   // force reflow
   void el.offsetWidth;
   // re-add the animated cl
   el.classList.add('animate__animated', 'animate__flipInX');
 }
});


// Bounce in Left Animation on any item with the .bouncein-left class
ScrollOut({
  targets: '.bouncein-left',
  onShown: function (el) {
       // remove the class
   el.classList.remove('animate__animated', 'animate__bounceInLeft');
   // force reflow
   void el.offsetWidth;
   // re-add the animated cl
      el.classList.add('animate__animated', 'animate__bounceInLeft');
      var delay = 100 * Array.from(document.querySelectorAll('.bouncein-left')).indexOf(el) + 500;
      el.style.animationDelay = delay + 'ms';
  },
});

// Bounce in Right Animation on any item with the .bouncein-right class
ScrollOut({
  targets: '.bouncein-right',
  onShown: function (el) {
       // remove the class
   el.classList.remove('animate__animated', 'animate__bounceInRight');
   // force reflow
   void el.offsetWidth;
   // re-add the animated cl
      el.classList.add('animate__animated', 'animate__bounceInRight');
      var delay = 100 * Array.from(document.querySelectorAll('.bouncein-right')).indexOf(el) + 500;
      el.style.animationDelay = delay + 'ms';
  },
});

// Bounce in Up Animation on any item with the .bouncein-up class
ScrollOut({
  targets: '.bouncein-up',
  onShown: function (el) {
       // remove the class
   el.classList.remove('animate__animated', 'animate__bounceInUp');
   // force reflow
   void el.offsetWidth;
   // re-add the animated cl
      el.classList.add('animate__animated', 'animate__bounceInUp');
      var delay = 100 * Array.from(document.querySelectorAll('.bouncein-up')).indexOf(el) + 500;
      el.style.animationDelay = delay + 'ms';
  },
});


// Fade Up Effect Animation on any item with the .fadeup class
ScrollOut({
  targets:'.fadeup',
  onShown: function(el) {
   // remove the class
   el.classList.remove('animate__animated', 'animate__fadeInUp');
   // force reflow
   void el.offsetWidth;
   // re-add the animated cl
   el.classList.add('animate__animated', 'animate__fadeInUp');
 }
});


// core version + navigation, pagination modules:
//import Swiper, { Navigation, Autoplay } from 'swiper';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
// import Swiper and modules styles

// Swiper Testimonials
// init Swiper:
const swiper = new Swiper('.swiper', {
  // configure Swiper to use modules
  modules: [Navigation], 
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});


// Unused Swiper?
// init Swiper:
const swiper2 = new Swiper('.swiper2', {
  // configure Swiper to use modules
  modules: [Navigation], 
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});

// import Swiper JS
//import Swiper from 'swiper';
//import { Autoplay, Navigation } from 'swiper/modules';
// import Swiper styles
//import 'swiper/css';

const swiper3 = new Swiper('.swiper3', {
    // Optional parameters
    //direction: 'vertical',
	//modules: [Autoplay, Navigation],
  modules: [Navigation, Autoplay],
  loop: true,
	slidesPerView: 2,
  slidesPerGroup: 1,
  breakpoints: {
      782:{
          slidesPerView: 3,
          slidesPerGroup: 1,
      },
      992:{
          slidesPerView: 4,
          slidesPerGroup: 1,
      },
      1200:{
          slidesPerView: 5,
          slidesPerGroup: 1,
      },
  },
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay:5000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
    // Enable keyboard control
    keyboard: {
        enabled: true,
        onlyInViewport: false, // Allow keyboard control outside the viewport
    },
});

// Define an array of image sources
const imageSources = [
  "/wp-content/themes/wildwood/images/wildwood-plus-multicolour-logo.svg",
  "/wp-content/themes/wildwood/images/wildwood-plus-icon.svg", // Replace with the path to your second image
];

// Load in animated logo effect to any element with the class animate-logo
// Create the div with class "context"
const contextDiv = document.createElement("div");
contextDiv.classList.add("context");

// Create the div with class "area"
const areaDiv = document.createElement("div");
areaDiv.classList.add("area");

// Create the div with class "circles"
const circlesDiv = document.createElement("div");
circlesDiv.classList.add("circles");

// Initialize counters for image sources
let primaryImageCounter = 0;
let secondaryImageCounter = 0;

// Create the 9 divs with class "bg-image" and two images inside
for (let i = 0; i < 9; i++) {
  const bgImageDiv = document.createElement("div");
  bgImageDiv.classList.add("bg-image");

  // Determine which image to use
  let imageSource;
  if (primaryImageCounter < 3) {
    imageSource = imageSources[0]; // Use the primary image 3 times
    primaryImageCounter++;
  } else {
    imageSource = imageSources[1]; // Use the secondary image for the rest
    secondaryImageCounter++;
  }

  // Create an image element and set its source
  const image = document.createElement("img");
  image.setAttribute("src", imageSource);

  bgImageDiv.appendChild(image);
  circlesDiv.appendChild(bgImageDiv);
}

// Append the "circles" div to the "area" div
areaDiv.appendChild(circlesDiv);

// Append the "area" div to the "context" div
contextDiv.appendChild(areaDiv);

// Get all elements with class "animate-logo"
const animateLogos = document.querySelectorAll(".animate-logo");

// Loop through the animateLogos array and append the "contextDiv" to each one
animateLogos.forEach((element) => {
  element.appendChild(contextDiv.cloneNode(true));
});





// Split text into coloured rainbow characters for headings
Splitting({ target: '.rainbow-text h2' });
ScrollOut({
  targets: ['.word', '.rainbow-text']
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}

